import React from 'react';
import { CircularProgress, WithStyles, withStyles } from '@material-ui/core';
import styles from './styles';
import VTypography from '../VTypography/VTypography';
import VIcon from '../VIcon/VIcon';
import { ICONS_MAP } from '../VIcon/iconsMap';

interface VButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  label: string;
  disabled?: boolean;
  variant?:
    | 'brand'
    | 'primary'
    | 'secondary'
    | 'outlined'
    | 'destroyGhost'
    | 'destroy'
    | 'transparent'
    | 'text'
    | 'link';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  fullWidth?: 'always' | 'desktop' | 'mobile' | 'none';
  icon?: keyof typeof ICONS_MAP;
  mobileFullWidth?: boolean;
}

const VButton = ({
  classes,
  label,
  disabled,
  variant = 'brand',
  size = 'medium',
  href,
  target,
  onClick,
  loading,
  fullWidth = 'none',
  icon,
  ...rest
}: VButtonProps & WithStyles<typeof styles>) => {
  const buttonClassName = [
    classes.baseButtonContainer,
    classes[variant],
    classes[size],
    classes[`${variant}Text`],
    fullWidth ? classes[`${fullWidth}FullWidth`] : '',
    disabled ? classes.disabled : '',
  ];

  const buttonLabelClassName = [
    classes[`${variant}Text`],
    classes.labelContainer,
    loading ? classes.labelHidden : '',
  ];

  const circularProgressClassName = [
    classes[`${variant}Text`],
    classes.circularProgress,
    !loading ? classes.labelHidden : '',
  ];

  return (
    <a
      href={href}
      target={target}
      className={buttonClassName.join(' ')}
      onClick={onClick}
      {...rest}
    >
      <CircularProgress size={14} className={circularProgressClassName.join(' ')} />
      <div className={buttonLabelClassName.join(' ')}>
        {icon && <VIcon name={icon} size={20} color="inherit" />}
        <VTypography variant="button2" color="inherit">
          {label}
        </VTypography>
      </div>
    </a>
  );
};

export default withStyles(styles)(VButton);
